// extracted by mini-css-extract-plugin
export default {"historicalContainer":"style_historicalContainer__vQZvD","infoBadge":"style_infoBadge__KBHfU","historicIcon":"style_historicIcon__AwJiW","loaddMoreBtn":"style_loaddMoreBtn__KSenI"};